// We ignore special cases of donations (forwarded, mateched) here

import React, { useState } from 'react'
import { formatCents, useJsonApi } from 'shared'

import Pagination from 'react-js-pagination'
import classNames from 'classnames'
import moment from 'moment'

import IconHeart from '/app/assets/images/icons/heart.svg'

export const AbDonationsList = ({ apiUrl }: { apiUrl: string }) => {
  type Donation = any
  type DonationList = {
    current_page: number
    data: Array<Donation>
    offset: number
    per_page: number
    total_entries: number
    total_pages: number
  }

  const [activePage, setActivePage] = useState(1)
  const [perPage, setPerPage] = useState(3)

  const { data: donationList } = useJsonApi<DonationList>(
    apiUrl + `?per_page=${perPage}&page=${activePage}&order=confirmed_at:desc`
  )

  const handlePageChange = (pageNumber: number) => {
    setActivePage(pageNumber)
  }

  const handleLoadMore = () => {
    setPerPage(6)
  }

  if (!donationList || donationList?.data.length === 0) return null

  return (
    <div className="bg-gray-100 pb-4">
      {donationList.data.map((donation, index) => (
        <Donation key={index} index={index} donation={donation} />
      ))}
      {perPage === 3 && donationList.total_entries > 3 && (
        <button className="simulated-link mt-4 block" onClick={handleLoadMore}>
          {I18n.locale === 'de' ? 'Alle Spenden' : 'All donations'}
        </button>
      )}
      {perPage > 3 && donationList.total_entries > 6 && (
        <Pagination
          activePage={activePage}
          itemsCountPerPage={donationList.per_page}
          totalItemsCount={donationList.total_entries}
          pageRangeDisplayed={5}
          onChange={handlePageChange}
          hideFirstLastPages={true}
          innerClass="ab-pagination"
          activeClass="current"
        />
      )}
    </div>
  )
}

const Donation = ({ donation, index }: any) => {
  moment.locale(`${I18n.locale === 'de' ? 'de' : 'en'}`)

  return (
    <div className=" flex bg-white px-4 py-2 mb-1 flex-col">
      <div className="flex items-center">
        <div
          className={classNames(
            'rounded-full w-14 h-14 flex justify-center items-center text-white',
            index % 2 === 0 ? 'bg-teal-700' : 'bg-purple-700'
          )}
        >
          {donation.donated_amount_in_cents ? (
            <FluidText content={formatCents(donation.donated_amount_in_cents)} />
          ) : (
            <img className="w-6 h-6" src={IconHeart} />
          )}
        </div>
        <div className="ml-4 flex flex-col">
          <div className="font-bold">
            {donation.author ? donation.author.name : I18n.locale === 'de' ? 'Anonym' : 'Anonymous user'}
          </div>
          <div className="text-sm text-gray-700">{moment(donation.confirmed_at).fromNow()}</div>
        </div>
      </div>
      {donation.message && <div className="mt-2 text-sm" dangerouslySetInnerHTML={{ __html: donation.message }} />}
    </div>
  )
}

const FluidText = ({ content }: { content: string }) => {
  const size = (6 / content.length).toString() + 'rem'

  return (
    <span className="font-bold" style={{ fontSize: `min(${size}, 1rem)` }}>
      {content}
    </span>
  )
}
